import { useContext } from "react"
import type { PolyglotContextValue } from "./PolyglotContext"
import { PolyglotContext } from "./PolyglotContext"

export function usePolyglot(): PolyglotContextValue {
  return useContext(PolyglotContext)
}
